var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravelBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27 7h-5v-1a3 3 0 0 0 -3-3h-6a3 3 0 0 0 -3 3v1h-5a3 3 0 0 0 -3 3v16a3 3 0 0 0 3 3h22a3 3 0 0 0 3-3v-16a3 3 0 0 0 -3-3zm-15-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1h-8zm-7 21a1 1 0 0 1 -1-1v-16a1 1 0 0 1 1-1h3v18zm5 0v-18h12v18zm18-1a1 1 0 0 1 -1 1h-3v-18h3a1 1 0 0 1 1 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelBag);
export default __webpack_public_path__ + "static/media/travel-bag.6c4a035e7c3d6a88a15792ff6e78255a.svg";
export { ForwardRef as ReactComponent };